export const getGa = () => globalThis.ga;
